export const rpcUrls = {
  btc: {
    bitcoin: ['https://blockstream.info/api', 2],
    bitcoin_testnet: ['https://blockstream.info/testnet/api', 2]
  },
  eth: {
    mainnet: ['https://mainnet.infura.io/v3/da99ebc8c0964bb8bb757b6f8cc40f1f'],
    ropsten: ['https://ropsten.infura.io/v3/da99ebc8c0964bb8bb757b6f8cc40f1f'],
    rinkeby: ['https://rinkeby.infura.io/v3/da99ebc8c0964bb8bb757b6f8cc40f1f'],
    kovan: ['https://kovan.infura.io/v3/da99ebc8c0964bb8bb757b6f8cc40f1f'],
    goerli: ['https://goerli.infura.io/v3/da99ebc8c0964bb8bb757b6f8cc40f1f']
  }
}

export const checkRpc = (chain, network, rpc) => {
  if (!rpc) return false

  return true
}

export const getDefaultRpcConfig = (chain, network) => {
  return rpcUrls[chain][network]
}
